module.exports = function() {
  return new Worker(__webpack_public_path__ + "1b4d9e61fd19dc727bdb.worker.js");
};